<template>
	<div style="font-family: Roboto">
		<v-breadcrumbs :items="items" class="font-weight-bold">
			<template v-slot:divider>
				<v-icon icon="mdi-chevron-right"></v-icon>
			</template>
		</v-breadcrumbs>
		<div>
			<v-card class="mx-4 px-8 py-4" rounded="xl">
				<v-row>
					<v-col cols="9">
						<div class="my-5 d-flex">
							<v-icon :color="colorCode[incidentDetail.priority]" size="x-large">
								mdi-flag
							</v-icon>
							<div class="font-weight-bold ml-5 text-h5" v-if="incidentDetail.type == 'esg'">
								ESG - {{ incidentDetail.workType }}
							</div>
							<div class="font-weight-bold ml-5 text-h5" v-else>
								{{ incidentDetail.title }}
							</div>
						</div>
					</v-col>
					<v-col cols="3">
						<div class="d-flex" style="flex-direction: row-reverse">
							<div class="mt-4">
								<v-menu>
									<template v-slot:activator="{ props }">
										<div v-bind="props">
											<v-btn class="margin-right-2 rounded-e-0 rounded-s-lg text-white" :style="{
												backgroundColor:
													getStatusColor(
														incidentDetail.status
													),
											}">
												{{ incidentDetail.status }}
											</v-btn>
											<v-btn class="rounded-s-0 rounded-e-lg text-white" size="xs-small"
												style="padding-block: 3px" :style="{
													backgroundColor:
														getStatusColor(
															incidentDetail.status
														),
												}">
												<v-icon color="white" size="30">mdi-chevron-down</v-icon>
											</v-btn>

											<v-menu>
												<template v-slot:activator="{ props }">
													<v-icon v-if="
														incidentDetail.status ==
														'to-do'
													" @click="OpenDeleteMenu" v-bind="props">mdi-dots-vertical</v-icon>
												</template>

												<v-list class="rounded-lg mt-4">
													<v-list-item class="text-red-lighten-1 d-flex align-center"
														style="width: 200px" @click.stop="
															isIncidentDeleteDialogOpen =
															'true'
															">
														<v-icon class="mr-4">
															mdi-trash-can-outline
														</v-icon>

														<span>{{ $t('delete') }}</span>
													</v-list-item>
												</v-list>
											</v-menu>
										</div>
									</template>
									<v-list v-if="
										incidentDetail.status ===
										'in-progress'
									" class="mt-2 border text-grey" elevation="0">
										<v-list-item @click="
											reviewIncident(
												this.incidentDetail.id
											)
											">
											<v-list-item-title>
												<span class="pa-3 bg-purple mr-2 rounded-xs"></span>
												In Review
											</v-list-item-title>
										</v-list-item>
									</v-list>
									<v-list v-if="
										incidentDetail.status ===
										'in-review'
									" class="mt-2 border text-grey" elevation="0">
										<v-list-item @click="
											moneyTransferDialogue = true
											">
											<v-list-item-title>
												<span class="pa-3 bg-green mr-2 rounded-xs"></span>
												Complete
											</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</div>
						</div>
					</v-col>
				</v-row>

				<v-card class="border pa-5 rounded-lg bg-amber-lighten-5" elevation="0"
					v-if="showRelatedIncident && linkedIncidents.length > 0">
					<div>
						<div class="font-weight-bold text-yellow-darken-2 text-h5">
							Related
						</div>
						<div class="font-weight-bold text-grey">
							Incidents that are related but don't rely on
							each other
						</div>
						<div v-if="!(linkedIncidents.length === 0)">
							<table v-for="incidents in linkedIncidents" width="100%">
								<tr>
									<td width="10%">
										<v-icon icon="mdi-flag" :color="colorCode[incidents.priority]
											"></v-icon>
									</td>
									<td width="30%">
										{{ incidents.title }}
									</td>
									<td width="30%">
										{{ incidents.client.name }}
									</td>
									<td width="20%">
										<v-chip v-if="!incidents.isPublished">
											Draft
										</v-chip>

										<v-chip v-else class="ma-1" size="small" :style="{
											'background-color':
												incidents.status == 'to-do'
													? '#A3A3A3'
													: incidents.status ==
														'in-progress'
														? '#FBC816'
														: incidents.status ==
															'in-review'
															? '#8045CB'
															: '#12C138',
										}" color="white">
											{{ incidents.status.toUpperCase() }}
										</v-chip>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</v-card>
				<div v-if="incidentDetail.type == 'esg'">
					<v-row>
						<v-cols cols="12">
							<div class="d-flex font-weight-600">
								<div class="mr-8">
									<div class="my-2 mx-3">{{ $t('organization_name') }}</div>
									<div class="my-2 mx-3">{{ $t('organization_type') }}</div>
									<div class="my-2 mx-3"
										v-if="incidentDetail.workType === 'Social Impact Assessment'">
										{{ $t('project_owner_department') }}</div>
									<div class="my-2 mx-3"
										v-if="incidentDetail.workType === 'Social Impact Assessment'">
										{{ $t('evaluation_responsibility_department') }}</div>

								</div>
								<div class="font-weight-medium">
									<div class="my-2 mx-6">
										{{ incidentDetail?.company?.name }}

									</div>
									<div class="my-2 mx-6">
										{{ incidentDetail?.company?.companyType }}
									</div>
									<div class="my-2 mx-6"
										v-if="incidentDetail.workType === 'Social Impact Assessment'">
										{{ incidentDetail?.project?.metadata?.ProjectOwnerDepartment }}
									</div>
									<div class="my-2 mx-6"
										v-if="incidentDetail.workType === 'Social Impact Assessment'">
										{{ incidentDetail?.project?.metadata?.EvaluationResponsibilityDepartment }}
									</div>
								</div>
							</div>
						</v-cols>
					</v-row>
				</div>

				<v-divider class=my-3></v-divider>

				<v-row>
					<v-col cols="12">
						<div class="d-flex font-weight-600">
							<div class="mr-8">
								<div class="my-2">{{ $t('customer') }}</div>
								<div class="my-2">{{ $t('contact_number') }}</div>
								<div class="mr-8">
									<div class="my-2">{{ $t('email') }}</div>
									<div class="my-2">{{ $t('created') }}</div>
								</div>
							</div>
							<div class="font-weight-medium">
								<div class="my-2">
									{{ clientDetails.name }}
								</div>
								<div class="my-2">
									{{ clientDetails.phone }}
								</div>
								<div class="my-2">
									{{ clientDetails.email }}
								</div>
								<div class="my-2">
									{{ dateCreated }}
								</div>
							</div>
						</div>
					</v-col>
				</v-row>
				<div class="font-weight-bold my-2">{{ $t('customer_note') }}</div>
				<v-textarea class="pa-2" rows="3" v-model="incidentDetail.note" elevation="0" variant="outlined"
					readonly>
				</v-textarea>
				<v-divider class="my-8"></v-divider>
				<div>
					<div v-if="notLoading">
						<div class="incident_jobs" v-for="(job, index) in incidentJobs" :key="job.id">
							<div v-if="incidentDetail.type === 'general'">
								<div class="job_description d-flex justify-space-between">
									<div class="mr-2 font-weight-bold mt-2">
										{{ incidentJobs.indexOf(job) + 1 }}. {{ $t('job_description') }}
									</div>
									<v-chip class="mt-2 text-white" :style="{
										backgroundColor: getStatusColor(
											job.status
										),
									}">
										{{ job.status }}
									</v-chip>
								</div>
								<div class="my-2" v-html="job.description"></div>

								<v-row>
									<v-col cols="12">
										<div class="d-flex">
											<div class="mr-10 font-weight-600">
												<div class="my-2">{{ $t('link') }}</div>
												<div class="my-2">{{ $t('location') }}</div>
												<div class="my-2">{{ $t('start_date') }}</div>
												<div class="my-2">
													{{ $t('working_period') }}
												</div>
												<div class="my-2">{{ $t('wages') }}</div>
											</div>
											<div class="ml-10 font-weight-medium">
												<div class="my-2">
													<a target="_blank" :href="job.link" v-if="job.link">{{ job.link
													}}</a>
													<span v-else>No link provided</span>
												</div>
												<div class="my-2">
													<a :href="job.address" v-if="
														isLocationLink(
															job.address
														)
													">{{ job.address }}</a>
													<span v-else>{{
														job.address
													}}</span>
												</div>
												<div class="my-2">
													{{ job.dueDate }}
												</div>
												<div class="my-2">
													{{ totalWorkingPeriod }}
													{{ job.workingPeriodUOM }}
												</div>
												<div class="my-2">
													{{ totalWages }}
												</div>
											</div>
										</div>
									</v-col>
								</v-row>
								<div class="font-weight-bold">{{ $t('skill_required') }}</div>
								<div class="my-3">
									<v-chip class="mr-2 mb-2 mb-md-0 text-white" v-for="skill in incidentSkills"
										:key="skill.id" density="default" :style="{
											'background-color': colorGenerator(
												skill.name
											),
										}">
										{{ skill.name }}
									</v-chip>
								</div>
								<div class="font-weight-bold">
									{{ $t('certificate') }}
								</div>
								<div class="my-3">
									<v-chip class="mr-2 mb-2 mb-md-0 text-white"
										v-for="certificate in incidentDetail.incidentCertificates"
										:key="certificate.certificateName.id" density="default" :style="{
											'background-color': colorGenerator(
												certificate.certificateName
											),
										}">
										{{ certificate.certificateName }}
									</v-chip>
								</div>
							</div>
							<div v-else>
								<div class="job_description d-flex justify-space-between">
									<div class="mr-2 font-weight-bold mt-2">
										{{ incidentJobs.indexOf(job) + 1 }}. {{ $t('job_description') }}
									</div>
									<v-chip class="mt-2 text-white" :style="{
										backgroundColor: getStatusColor(
											job.status
										),
									}">
										{{ job.status }}
									</v-chip>
								</div>
								<div class="mr-2 font-weight-bold mt-2">
									{{ incidentDetail.workType }} detail
								</div>
								<br>
								<div v-if="incidentDetail.workType === 'Social Impact Assessment'">
									<div>
										<div> {{ $t('project_details') }}: {{ incidentJobs[0].metadata.projectDetails }}
										</div>
									</div>
									<div> {{ $t('project_type') }}: {{ incidentJobs[0].metadata.projectsType }}</div>
									<div> {{ $t('additional_information') }} : <a target="_blank"
											:href="incidentJobs[0].metadata.link"
											v-if="incidentJobs[0].metadata.link">{{
												incidentJobs[0].metadata.link
											}}</a>
										<span v-else>No link provided</span>
									</div>
									<div>{{ $t('qualification') }}: {{ incidentJobs[0].metadata.qualificationType }}
									</div>

									<!-- Conditionally hide this div based on qualificationType -->
									<div class="d-flex"
										v-if="incidentJobs[0].metadata.qualificationType !== 'Standard Level 1'">
										<div class="mr-1">{{ $t('qualification_work_level') }}: {{
											incidentJobs[0].metadata.qualificationWorkType }}
										</div>,
										<div>
											<!-- First condition for 'Evaluation Team Level' or 'Project Manager Level' -->
											<div
												v-if="incidentJobs[0].metadata.qualificationWorkType === 'Evaluation Team Level' || incidentJobs[0].metadata.qualificationWorkType === 'Project Manager Level'">
												<div class="d-flex">
													<div class="mx-3">{{ $t('number_of_projects') }}:</div>
													<div class="mx-1">{{ incidentJobs[0].metadata.numberOfProjects }}
														projects</div>,
													<div class="mx-3">{{ $t('number_of_years') }}</div>
													<div class="mx-1">{{ incidentJobs[0].metadata.numberOfYears }} years
													</div>
												</div>
											</div>

											<!-- Second condition specifically for 'TYpe of Organization' -->
											<div
												v-else-if="incidentJobs[0].metadata.qualificationWorkType === 'Type of Organization'">
												<div class="d-flex">
													<div class="mx-3">{{ $t('organization_evaluated') }}:</div>
													<div class="mx-1">{{ incidentJobs[0].metadata.evaluated }}
													</div>,


												</div>
											</div>

											<!-- Type of Expertise -->
											<div
												v-else="incidentJobs[0].metadata.qualificationWorkType === 'Type of Expertise (Project/SDG Category)'">
												<div class="d-flex">
													<div class="mx-3">{{ $t('project_type') }}:</div>
													<div class="mx-1">{{ incidentJobs[0].metadata.project }}
													</div>,

												</div>
											</div>

										</div>


									</div>

									<div>{{ $t('evaluation_level') }}: {{ incidentJobs[0].metadata.evaluationLevel }}
									</div>
									<div>{{ $t('evaluation_type') }}: {{ incidentJobs[0].metadata.evaluationType }}
									</div>
									<span v-if="incidentJobs[0].metadata.evaluationPurpose === 'other'">
										{{ $t('evaluation_purpose') }}: {{ incidentJobs[0].metadata.evaluationPurpose }}
										:
										{{
											incidentJobs[0].metadata.otherPurpose }}
									</span>
									<span v-else>
										{{ $t('evaluation_purpose') }}: {{ incidentJobs[0].metadata.evaluationPurpose }}
									</span>
									<div>
										{{ $t('evaluation_verification_process') }}: {{
											incidentJobs[0].metadata.evaluationVerificationProcess }}
									</div>
									<div>{{ $t('start_date') }} - {{ $t('end_date') }}: {{
										formatDate(incidentJobs[0].metadata.startDate) }} -
										{{ formatDate(incidentJobs[0].metadata.dueDate) }}</div>
									<div>{{ $t('wages') }}: {{ incidentJobs[0].metadata.wages }} THB</div>
									<div>{{ $t('submission_detail') }}: {{ incidentJobs[0].metadata.submissionDetail }}
									</div>
									<div class="mr-2 font-weight-bold mt-2">
										{{ $t('skill_required') }}
									</div>
									<div>
										<v-chip class=" mr-2 mb-2 mb-md-0 text-white" v-for="skill in incidentSkills"
											:key="skill.id" density="default" :style="{
												'background-color': colorGenerator(
													skill.name
												),
											}">
											{{ skill.name }}</v-chip>
									</div>
								</div>

								<div v-else-if="incidentDetail.workType === 'Speaker'">

									<div>
										<div>{{ $t('speaker') }}: {{ incidentJobs[0].metadata.speakerType }}</div>
									</div>
									<div>{{ $t('course') }} : {{ incidentJobs[0].metadata.course }}</div>
									<div>{{ $t('objectives_details_process') }} : {{ incidentJobs[0].metadata.objectives
									}}
									</div>
									<div> {{ $t('mode_of_participation') }}: {{
										incidentJobs[0].metadata.participationType }}</div>
									<div> {{ $t('delivery_type') }} : {{ incidentJobs[0].metadata.deliveryType }} </div>
									<div class="d-flex"> {{ $t('participation_details') }}:
										<div v-if="incidentJobs[0].metadata.participationDetails === 'Level'">
											{{ incidentJobs[0].metadata.participationDetails }}
											{{ incidentJobs[0].metadata.levelInput }}
										</div>
										<div v-else>
											{{ incidentJobs[0].metadata.participants }} {{
												incidentJobs[0].metadata.participationDetails
											}}
										</div>
									</div>
									<div> {{ $t('date_and_time') }} :{{ formatDate(incidentJobs[0].metadata.startDate)
									}} </div>
									<div> {{ $t('location') }} : {{ incidentJobs[0].metadata.location }}</div>
									{{ $t('wages') }} <div> {{ $t('submission_detail') }} : </div>
									<div>{{ incidentJobs[0].metadata.submissionDetail }}</div>

									<div class="mr-2 font-weight-bold mt-2">
										{{ $t('skill_required') }}
									</div>
									<div>
										<v-chip class=" mr-2 mb-2 mb-md-0 text-white" v-for="skill in incidentSkills"
											:key="skill.id" density="default" :style="{
												'background-color': colorGenerator(
													skill.name
												),
											}">
											{{ skill.name }}</v-chip>
									</div>
								</div>

								<div
									v-else-if="incidentDetail.workType === 'Writing Social Return on Investment (SROI) Reports'">

									<div>{{ $t('sroi_report_format') }}: {{ incidentJobs[0].metadata.SROIType }}</div>
									<div> {{ $t('link_to_report_format') }} : <a target="_blank"
											:href="incidentJobs[0].metadata.link"
											v-if="incidentJobs[0].metadata.link">{{
												incidentJobs[0].metadata.link
											}}</a>
										<span v-else>No link provided</span>
									</div>

									<div>{{ $t('project_details') }} : {{ incidentJobs[0].metadata.detailProject }}
									</div>

									<div> {{ $t('delivery_timeline') }} :{{
										formatDate(incidentJobs[0].metadata.startDate) }} </div>
									<div> {{ $t('wages') }} : {{ incidentJobs[0].metadata.wages }} baht</div>
									<div> {{ $t('submission_detail') }} : </div>
									<div>{{ incidentJobs[0].metadata.submissionDetail }}</div>

									<div class="mr-2 font-weight-bold mt-2">
										{{ $t('skill_required') }}
									</div>
									<div>
										<v-chip class=" mr-2 mb-2 mb-md-0 text-white" v-for="skill in incidentSkills"
											:key="skill.id" density="default" :style="{
												'background-color': colorGenerator(
													skill.name
												),
											}">
											{{ skill.name }}</v-chip>
									</div>
								</div>
								<div
									v-else-if="incidentDetail.workType === 'Consulting/Coaching Team for Social Impact Assessment'">
									<div class="d-flex">
										{{ $t('job_type') }}:
										<div class="ml-2">
											<template v-if="incidentJobs.length && incidentJobs[0].metadata">
												<template v-if="incidentJobs[0].metadata.jobType === 'Other'">
													{{ incidentJobs[0].metadata.jobType }} : {{
														incidentJobs[0].metadata.otherType }}
												</template>
												<template v-else>
													{{ incidentJobs[0].metadata.jobType }}
												</template>
											</template>
										</div>
									</div>

									<div> {{ $t('job_details') }}</div>
									<div>{{ incidentJobs[0].metadata.jobDetail }}</div>
									<div>{{ $t('timeline') }}: {{ formatConsultDate(incidentJobs[0].metadata.startDate)
									}} - {{
											formatConsultDate(incidentJobs[0].metadata.endDate) }} </div>
									<div>
										{{ $t('number_of_hours') }}: {{ incidentJobs[0].metadata.workingPeriod }} {{
											incidentJobs[0].metadata.workingPeriodUOM }}
									</div>
									<div>
										{{ $t('wages') }}: {{ incidentJobs[0].metadata.wages }} THB
									</div>
									<div> {{ $t('submission_detail') }}</div>
									<div>{{ incidentJobs[0].metadata.submissionDetail }}</div>
									<div class="font-weight-bold"> {{ $t('skill_required') }}</div>
									<div class="my-3">
										<v-chip class="mr-2 mb-2 mb-md-0 text-white" v-for="skill in incidentSkills"
											:key="skill.id" density="default" :style="{
												'background-color': colorGenerator(
													skill.name
												),
											}">
											{{ skill.name }}
										</v-chip>
									</div>
								</div>

							</div>
							<v-tabs v-model="tab" slider-color="#FF7E87">
								<v-tab value="one">{{ $t('agent') }}</v-tab>
								<v-tab value="two">{{ $t('submit_job') }}</v-tab>
								<v-tab value="three">{{ $t('service_report') }}</v-tab>
							</v-tabs>

							<v-card-text>
								<v-window v-model="tab">
									<v-window-item value="one">
										<div>
											<div class="d-flex justify-space-between agent-application ma-2">
												<div v-if="this.agentSelected" class="font-weight-bold mt-3">
													<div class="text-h6 mb-2">
														{{ $t('assigned_agent') }} (1)
													</div>
													<div>
														{{ $t('assigned_date') }}:
														{{
															selectedAgent.updatedAt
														}}
													</div>
												</div>
											</div>
											<div></div>
											<v-card v-if="!agentSelected" class="agent-details ma-2 pa-3" rounded="xl">
												<div class="d-flex justify-space-between agent-application ma-2 pa-2">
													<div v-if="!agentSelected" class="font-weight-bold mt-3">
														<div class="text-h6 mb-2">
															{{ $t('agent_list') }} ({{
																applicants.length
															}})
														</div>
													</div>

													<div class="search-bars w-50">

														<v-text-field v-if="
															!this.agentSelected
														" prepend-inner-icon="mdi-magnify" placeholder="Search" bg-color="white" rounded id="search"
															name="search" variant="solo" hide-details
															v-model="searchQuery" density="compact"
															@keyup.enter="this.fetchAgentList(searchQuery)" />

													</div>

												</div>
												<v-tabs v-model="tabAgent" slider-color="#FF7E87">
													<v-tab value="one" class="text-none">{{ $t('interested_agent')
													}}</v-tab>
													<v-tab value="two" class="text-none">{{ $t('verified_agent')
													}}</v-tab>
												</v-tabs>

												<div>
													<v-window v-model="tabAgent">
														<v-window-item value="one">
															<ApplicantsDataTable :headers="headers" :items="applicants"
																@totalRowsPerPage="filterRowsPerPage"
																@pageNumber="changePage"
																@assignAgent="handelAssignAgent" />
														</v-window-item>

														<v-window-item value="two">
															<AssignVerifiedAgent :applications-data="verifiedAgentList"
																:search-data="agentData"
																@assign-incident-to-agent="assignToVerifiedAgent"
																:incident-id="incidentDetail.id"
																@close-dialog="closeChangeAgentDialog" />
														</v-window-item>
													</v-window>
												</div>
												<!-- <ApplicantsDataTable :headers="headers" :items="applicants"
													@assignAgent="handelAssignAgent" /> -->
											</v-card>
											<div v-else class="ma-2 mt-5">
												<v-card label variant="outlined" rounded="xl">
													<div class="my-5 mx-10">
														<v-row>
															<v-col cols="2">
																<div class="d-flex justify-center">
																	<v-avatar size="150" image="@/assets/userphoto.jpg"
																		class="mt-4"></v-avatar>
																</div>
															</v-col>
															<v-col cols="7">
																<div class="ml-10">
																	<div class="d-flex" style="
																		margin: auto;
																		align-items: center;
																	">
																		<div class="text-h5 font-weight-bold">
																			{{ $t('line_name') }}:
																			{{
																				selectedAgent.lineName
																			}}
																		</div>
																		<v-rating v-model="agentFeedback
																			" empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half" half-increments
																			density="comfortable"
																			class="pl-2 ml-10 mb-1" disabled
																			color="yellow-darken-3"></v-rating>
																	</div>
																	<div>
																		<div class="text-subtitle-1">
																			Specialization
																			Skills
																		</div>
																		<div class="my-2">
																			<v-chip class="mr-2 mb-2 mb-md-0 text-white"
																				v-for="skill in selectedAgent.skills"
																				:key="skill.id
																					" density="comfortable" :style="{
																						'background-color':
																							colorGenerator(
																								skill.name
																							),
																					}">
																				{{
																					skill.name
																				}}
																			</v-chip>
																		</div>
																	</div>
																	<div class="text-h6 text-grey-darkn-1 my-2">
																		{{
																			selectedAgent.designation
																		}}
																	</div>
																	<div class="text-black">
																		<v-row>
																			<v-col cols="4">
																				<div class="my-2">
																					{{
																						`${selectedAgent.firstName}
																					${selectedAgent.lastName}`
																					}}
																				</div>
																				<div class="my-2">
																					{{
																						selectedAgent.phone
																					}}
																				</div>
																			</v-col>
																			<v-col cols="8">
																				<div class="my-2">
																					{{
																						selectedAgent.email
																					}}
																				</div>
																				<div class="my-2">
																					{{
																						selectedAgent.address
																					}}
																				</div>
																			</v-col>
																		</v-row>
																	</div>
																</div>
															</v-col>
															<v-col cols="3"
																class="d-flex flex-column justify-space-between">
																<!-- Top section: See agent profile link -->
																<div class="my-3 text-subtitle-2" @click="
																	agentProfile(
																		selectedAgent.id
																	)
																	" style="
																	display: flex;
																	flex-direction: row-reverse;
																	cursor: pointer;
																">
																	{{ $t('see_agent_profile') }} >
																</div>

																<!-- Bottom section: Change Agent button -->
																<div class="d-flex" style="
																	flex-direction: row-reverse;
																	margin-top: auto;
																">
																	<v-card-footer v-if="
																		incidentDetail.status ==
																		'in-progress'
																	">
																		<v-btn elevation="0" variant="outlined"
																			color="#FF7E87" rounded="xl" @click="
																				changeAgent = true
																				">
																			<div style="
																				color: black;
																			">
																				{{ $t('change_agent') }}
																			</div>
																		</v-btn>
																	</v-card-footer>
																	<v-card-footer v-else>
																		<v-btn elevation="0" color="#FF7E87"
																			rounded="xl" disabled variant="outlined">
																			<div style="
																				color: black;
																			">
																				{{ $t('change_agent') }}
																			</div>
																		</v-btn>
																	</v-card-footer>
																</div>
															</v-col>
														</v-row>
													</div>
												</v-card>
											</div>
											<div v-if="
												incidentDetail.status ==
												'complete'
											">
												<div class="mt-6 ml-5 text-h6">
													{{ $t('agent_rating_service') }}
												</div>
												<div class="d-flex ml-5 mt-5">
													<div style="
														text-decoration: underline;
														color: #1976d2;
													" id="link">
														{{
															`${this.url}/agentFeedback?incidentId=${this.incidentDetail.id}&applicationId=${this.applicationId}`
														}}
													</div>
													<div class="d-flex mx-3" style="
														color: #ff7e87;
														border-radius: 20px;
														cursor: pointer;
													" elevation="0" @click="copyToClipboard">
														<v-icon>mdi-content-copy</v-icon>
														<div style="
															text-decoration: underline;
														">
															{{ $t('copy_link') }}
														</div>
													</div>
												</div>

												<div class="mx-5 mt-5">
													<div class="text-body-1 font-weight-bold mb-5">
														{{ $t('incident_feedback') }}
													</div>
													<v-textarea variant="outlined" readonly rounded="xl" v-model="incidentDetail.incidentFeedback
														"></v-textarea>
												</div>
											</div>
										</div>
									</v-window-item>

									<v-window-item value="two">
										<div v-if="
											incidentDetail.status ==
											'in-progress' ||
											incidentDetail.status ==
											'in-review' ||
											incidentDetail.status ==
											'complete'
										">
											<v-card variant="outlined" class="pa-5 mb-5" rounded="xl" color="grey">
												<div class="text-black font-weight-bold mb-2">
													{{ $t('submit_job') }}
												</div>
												<v-btn block elevation="0" class="bg-white pa-5 text-none" rounded="lg"
													prepend-icon="mdi-image-plus-outline" v-if="
														incidentDetail.status ==
														'in-progress' || incidentDetail.status == 'in-review'
													" @click="
														openFileSystem(index)
														">
													{{ $t('upload_file_or_image') }}
												</v-btn>
												<div v-if="
													submitJob[index]
														.selectedFiles
														.length > 0
												" class="d-flex flex-wrap">
													<v-card v-for="(
															image, i
														) in submitJob[index]
																	.selectedFiles" :key="i" class="my-5 mx-2 flex-wrap" max-width="250" min-width="250" rounded="xl">
														<div style="
																position: relative;
															">
															<v-icon color="white" class="bg-black ma-2" style="
																	position: absolute;
																	top: 0;
																	right: 0;
																	cursor: pointer;
																	border-radius: 50%;
																" @click="
																	removePhoto(
																		index,
																		i
																	)
																	">
																mdi-close
															</v-icon>
															<img :src="image.url" alt="" height="200" />
														</div>
														<div class="d-flex justify-space-between ma-2">
															<div>
																<div class="font-weight-bold">
																	{{
																		image.displayName
																	}}
																</div>
																<div>
																	{{
																		formatDate(
																			image.lastModifiedDate
																		)
																	}}
																</div>
															</div>
															<v-avatar image="@/assets/userphoto.jpg"></v-avatar>
														</div>
													</v-card>
												</div>
												<div v-if="submitJob[index].selectedDocument.length > 0"
													class="d-flex flex-wrap">
													<v-card v-for="(doc, i) in submitJob[index].selectedDocument"
														:key="'doc-' + i" class="my-5 mx-2 flex-wrap" max-width="250"
														min-width="250" rounded="xl">
														<div style="position: relative;">
															<v-icon color="white" class="bg-black ma-2" style="
              position: absolute;
              top: 0;
              right: 0;
              cursor: pointer;
              border-radius: 50%;
            " @click="removeDocument(index, i)">
																mdi-close
															</v-icon>
															<v-icon color="primary" class="ma-4" size="40"
																v-if="doc.type.includes('application/pdf')">
																mdi-file-pdf-box
															</v-icon>
															<div class="font-weight-bold text-center pa-2" v-else>
																{{ doc.displayName }}
															</div>
														</div>
														<div class="d-flex justify-space-between ma-2">
															<div>
																<div class="font-weight-bold">{{ doc.displayName }}
																</div>
																<div>{{ formatDate(doc.lastModifiedDate) }}</div>
															</div>
														</div>
													</v-card>
												</div>


												<!-- ########################## STATUS IN-REVIEW & COMPLETE ################################# -->
												<div class="mt-4 d-flex flex-wrap" v-if="
													incidentDetail.status ==
													'complete' ||
													job.status == 'complete'
												">
													<div v-for="(
															jobPhotos, index
														) in job.jobPhotos" :key="index" class="ma-2">
														<v-card height="200" :image="jobPhotos.imageUrl
															" min-width="250" max-width="250" class="rounded-t-xl" @click="
																openImageDialog(
																	job.jobPhotos,
																	index
																)
																">
															<v-menu location="top">
																<template v-slot:activator="{
																	props,
																}">
																	<v-btn icon="mdi-dots-vertical" v-bind="props
																		" style="
																			position: absolute;
																			right: 0;
																			border-radius: 50%;
																			z-index: 1000;
																		" class="ma-2"></v-btn>
																</template>

																<v-list
																	class="mb-3 rounded-xl text-red-lighten-1 cursor-pointer">
																	<v-list-item prepend-icon="mdi-delete" @click="
																		openDeleteDialog(
																			jobPhotos
																		)
																		">
																		{{ $t('delete') }}
																	</v-list-item>
																</v-list>
															</v-menu>
														</v-card>
														<div
															class="d-flex justify-space-between pa-2 border rounded-b-xl">
															<div>

																<p>

																	{{
																		jobPhotos.imageUrl
																			.substring(
																				jobPhotos.imageUrl.lastIndexOf(
																					'/'
																				) +
																				1
																			)
																			.substring(
																				jobPhotos.imageUrl
																					.substring(
																						jobPhotos.imageUrl.lastIndexOf(
																							'/'
																						) +
																						1
																					)
																					.lastIndexOf(
																						'-'
																					) +
																				1
																			)
																	}}
																</p>
																<p>
																	{{
																		jobPhotos.updatedAt
																	}}
																</p>
																<div>
																	{{
																		jobPhotos
																			.user
																			.firstName
																	}}
																	{{
																		jobPhotos
																			.user
																			.lastName
																	}}
																</div>
															</div>

															<v-avatar image="@/assets/userphoto.jpg"></v-avatar>
														</div>
													</div>
												</div>

												<div class="my-2 mx-1" style="font-weight: 500; color: black">
													{{ $t('files') }}
												</div>
												<div class="d-flex">
													<div v-for="(
															jobFiles, index
														) in job.jobFiles" :key="index" class="ma-2 pa-2 d-flex"
														style="border: 1px solid grey; border-radius: 50px; max-width: 330px;">
														<div class="d-flex my-2">
															<div class="mx-2"><v-icon color="black">mdi-file</v-icon>
															</div>
															{{
																jobFiles.fileUrl
																	.substring(
																		jobFiles.fileUrl.lastIndexOf(
																			'/'
																		) +
																		1
																	)
																	.substring(
																		jobFiles.fileUrl
																			.substring(
																				jobFiles.fileUrl.lastIndexOf(
																					'/'
																				) +
																				1
																			)
																			.lastIndexOf(
																				'-'
																			) +
																		1
																	)
															}}


														</div>
														<div class="d-flex my-2 mx-2"
															style="color: #ff7e87; cursor: pointer;">
															<a :href="jobFiles.fileUrl" target="_blank"
																rel="noopener noreferrer" download
																style="display: flex; align-items: center;  color: #ff7e87; margin-right: 3px;">
																<span style="text-decoration: underline;">Download
																	{{ $t('files') }}</span>
																<!-- <v-icon>mdi-download</v-icon> -->
															</a>
															<v-icon>mdi-tray-arrow-down</v-icon>
														</div>

													</div>
												</div>

												<div class="text-black font-weight-bold my-4">
													{{ $t('note') }}
												</div>
												<v-textarea v-if="
													incidentDetail.status ==
													'in-progress' &&
													job.status == 'complete' || incidentDetail.status == 'in-review' && job.status == 'complete'
												" v-model="submitJob[index].remark
													" variant="outlined" rounded="xl" color="grey" class="text-black" />
												<v-textarea v-else variant="outlined" rounded="xl" color="grey"
													class="text-black" v-model="job.agentRemark" :disabled="!(
														incidentDetail.status ==
														'in-progress'
													)
														" />
												<div class="d-flex justify-end">
													<v-btn v-if="
														incidentDetail.status ==
														'in-progress' || incidentDetail.status == 'in-review'
													" elevation="0" rounded="xl" color="grey" @click="
														completeJob(
															job.id,
															index
														)
														">
														{{ $t('save_change') }}
													</v-btn>
												</div>
											</v-card>
										</div>
									</v-window-item>

									<v-window-item value="three">
										<v-card style="
												padding: 10px;
												border: 1px solid black;
												border-radius: 10px;
											">
											<div v-if="serviceReportStatus">
												<div class="font-weight-bold">
													{{ $t('agent_service_report') }}
												</div>
												<div>
													<div class="my-3">
														<div class="font-weight-bold">
															{{ $t('service_request_information') }}
														</div>
														<div>
															{{
																serviceReportData.requestInfo
															}}
														</div>
													</div>
													<div class="my-3">
														<div class="font-weight-bold">
															{{ $t('service_performed') }}
														</div>
														<div>
															{{
																serviceReportData.serviceInfo
															}}
														</div>
													</div>

													<div class="my-3">
														<div class="font-weight-bold">
															{{ $t('recommendation_and_other_detail') }}
														</div>
														<div>
															{{
																serviceReportData.recommendation
															}}
														</div>
													</div>
												</div>
											</div>
											<div v-else>
												<div>
													{{ $t('agent_service_report') }}
												</div>
												<div style="
														display: flex;
														flex-direction: column;
														align-items: center;
														justify-content: center;
														margin: 10px;
													">
													<div style="margin: auto">
														<v-img src="@/assets/servicePhoto.png" width="300px"></v-img>
													</div>
													<div class="mt-4 text-h5">
														{{ $t('no_service_report') }}
													</div>
												</div>
											</div>
										</v-card>
									</v-window-item>
								</v-window>
							</v-card-text>
						</div>


					</div>
				</div>
			</v-card>
		</div>
		<v-dialog v-model="assignAgent" width="auto" persistent>
			<v-card>
				<div class="ma-5">
					<v-row>
						<v-col cols="3">
							<v-avatar size="150" image="@/assets/userphoto.jpg" class="mt-4"></v-avatar>
						</v-col>
						<v-col cols="9">
							<div class="ml-5">
								<div class="d-flex justify-space-between">
									<div class="text-h5 font-weight-bold">
										<div>
											{{ $t('line_name') }}:
											{{ selectedAgent.lineName }}
										</div>
									</div>

									<div class="font-weight-bold cursor-pointer">
										<a href="#" class="agent-profile-link" @click="
											agentProfile(selectedAgent.id)
											">
											{{ $t('see_agent_profile') }}
											<v-icon>mdi-chevron-right</v-icon>
										</a>
									</div>
								</div>

								<v-row class="mt-2">
									<v-col cols="6" class="text-body-2">
										<div class="text-h6 text-grey-darkn-1 my-2">
											{{ selectedAgent.designation }}
										</div>
										<div class="text-grey">
											<div>
												{{
													`${selectedAgent.firstName} ${selectedAgent.lastName}`
												}}
											</div>
											<div>{{ selectedAgent.phone }}</div>
											<div>{{ selectedAgent.email }}</div>
											<div>
												{{ selectedAgent.address }}
											</div>
										</div>
									</v-col>
									<v-col cols="6" class="text-body-2">
										<div class="text-body-1 font-weight-bold">
											Specialization Skills
										</div>
										<div class="text-body-2 font-weight-bold">
											{{ selectedAgent.specialization }}
										</div>
										<div class="mt-2 text-body-1 font-weight-bold">
											{{ $t('skill_required') }}
										</div>
										<div class="mt-2">
											<v-chip class="mr-2 my-2 mb-md-0 text-white"
												v-for="skill in selectedAgent.skills" :key="skill.id"
												density="comfortable" :style="{
													'background-color':
														colorGenerator(
															skill.name
														),
												}">
												{{ skill.name }}
											</v-chip>
										</div>
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>
				</div>
				<v-card-footer class="bg-black w-100 d-flex justify-space-between mt-2 pa-2">
					<v-btn elevation="0" class="bg-black text-white" @click="assignAgent = false">
						{{ $t('cancel') }}
					</v-btn>

					<v-btn class="bg-black text-white" @click="
						setAgent(
							this.incidentDetail.id,
							this.selectedAgentApplicationId
						)
						"> {{ $t('assign') }}</v-btn>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-dialog v-model="moneyTransferDialogue" width="600">
			<v-card>
				<div class="ma-6 text-h6">
					{{ $t('money_will_be_transferred') }}.
					<span class="text-red-lighten-2">{{ $t('please_check_incident_completed') }}</span>
				</div>
				<v-card-footer class="bg-black w-100 d-flex justify-space-between mt-2 pa-2">
					<v-btn elevation="0" class="bg-black text-white" @click="moneyTransferDialogue = false">
						{{ $t('cancel') }}
					</v-btn>
					<v-btn class="bg-black text-white" @click="openFeedbackDialog">
						{{ $t('confirm') }}
						<v-icon>mdi-arrow-right-thin-circle-outline </v-icon>
					</v-btn>
				</v-card-footer>
			</v-card>
		</v-dialog>

		<v-dialog v-model="imageDialog" max-width="100%" class="show-image-dialog">
			<div style="position: absolute; top: -210px; right: 0; padding: 10px">
				<v-icon class="close-image" size="xx-large" @click="closeDialog">mdi-close-circle
				</v-icon>
			</div>
			<div style="display: flex; justify-content: center">
				<v-carousel hide-delimiters show-arrows="hover" v-model="selectedImage">
					<v-carousel-item v-for="(images, index) in jobImages" :key="index">
						<div style="
								display: flex;
								justify-content: center;
								height: 100%;
							">
							<img :src="images.imageUrl" alt="Job Image" cover style="height: 100%" />
						</div>
					</v-carousel-item>
				</v-carousel>
			</div>
		</v-dialog>

		<v-dialog v-model="feedbackDialogue" width="600">
			<v-card>
				<div class="d-flex ma-5">
					<div class="font-weight-bold" id="link">
						{{
							`${this.url}/agentFeedback?incidentId=${this.incidentDetail.id}&applicationId=${this.applicationId}`
						}}
					</div>
					<div>
						<v-btn color="#FF7E87" style="color: white; border-radius: 20px" elevation="0"
							@click="copyToClipboard">
							{{ $t('copy_link') }}
						</v-btn>
					</div>
				</div>
				<div class="text-center mb-5">
					{{ $t('copy_agent_feedback_link') }}
				</div>
				<v-divider class="mx-10"></v-divider>
				<div class="mx-5 mt-5">
					<div class="text-body-1 font-weight-bold mb-5">
						{{ $t('incident_feedback') }}
					</div>
					<v-textarea variant="outlined" v-model="incidentFeedback"></v-textarea>
				</div>
				<v-card-footer class="bg-black w-100 d-flex flex-row-reverse mt-2 pa-2">
					<v-btn class="bg-black text-white" @click="closeIncident">
						{{ $t('confirm') }}
						<v-icon>mdi-arrow-right-thin-circle-outline </v-icon>
					</v-btn>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-dialog v-model="changeAgent" width="900">
			<v-card>
				<v-card-header class="bg-black">
					<div class="d-flex justify-space-between mx-2 pa-2">
						<div>{{ $t('change_agent') }}</div>
						<div @click="changeAgent = false">
							<v-icon>mdi-close</v-icon>
						</div>
					</div>
				</v-card-header>
				<v-card-text>
					<v-row>
						<v-col cols="6">
							<div class="d-flex">
								<div><v-icon>mdi-account-circle</v-icon></div>
								<div class="ml-2 font-weight-bold">
									{{ $t('confirm_delete_agent') }}
								</div>
							</div>
						</v-col>
						<v-col>
							<div>
								<v-text-field variant="outlined" density="compact" hide-details
									:placeholder="$t('search')" prepend-inner-icon="mdi-magnify" v-model="searchQuery"
									@keyup.enter="this.fetchAgentList(searchQuery)" class="mr-10"
									rounded="xl"></v-text-field>
							</div>
						</v-col>
					</v-row>

					<v-tabs v-model="changeTab" slider-color="#FF7E87">
						<v-tab value="one" class="text-none">{{ $t('interested_agent') }}</v-tab>
						<v-tab value="two" class="text-none">{{ $t('verified_agent') }}</v-tab>
					</v-tabs>

					<div>
						<v-window v-model="changeTab">
							<v-window-item value="one">
								<ChangeAgent :applications-data="applications" :incident-id="incidentDetail.id"
									@close-dialog="closeChangeAgentDialog" @change-agent="changeApplicant"
									@showAgent="showAgent" />
							</v-window-item>

							<v-window-item value="two">
								<ChangeVerifiedAgent :applications-data="verifiedAgentList" :search-data="agentData"
									:incident-id="incidentDetail.id" @close-dialog="closeChangeAgentDialog"
									@assignIncidentToAgent="changeApplicant" />
							</v-window-item>
						</v-window>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="deleteDialog" width="500">
			<v-card>
				<v-card-title class="text-center ma-2">{{ $t('do_you_want_to') }}
					<span class="text-red-lighten-1">{{ $t('delete_image') }}</span>?</v-card-title>
				<v-card-footer>
					<div class="d-flex justify-space-between bg-black pa-2">
						<v-btn class="bg-black font-weight-bold" elevation="0" @click="deleteDialog = false">
							{{ $t('cancel') }}</v-btn>
						<v-btn class="bg-black font-weight-bold" @click="deletePhoto"> {{ $t('confirm') }}</v-btn>
					</div>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-dialog v-model="isIncidentDeleteDialogOpen" width="500">
			<v-card rounded="lg">
				<v-card-text>
					<div class="text-h6 mb-2 font-weight-bold">
						{{ $t('delete_incident') }} ?
					</div>
					<div>
						{{ $t('confirm_delete_incident') }}
						<span style="color: #ff7e87">
							{{ $t('incident_delete_warning') }}</span>
					</div>
				</v-card-text>
				<v-card-footer>
					<div class="d-flex ma-3 flex-row-reverse">
						<div>
							<v-btn variant="text" rounded="xl" class="text-black bg-red-lighten-4"
								@click="deleteAccount(incidentDetail.id)"> {{ $t('delete') }}</v-btn>
						</div>
						<div>
							<v-btn variant="text" class="mr-2" @click="isIncidentDeleteDialogOpen = false">
								{{ $t('cancel') }}</v-btn>
						</div>
					</div>
				</v-card-footer>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import incidentService from '@/services/API/incidentService'
import agentService from '@/services/API/agentService'
import applicationService from '@/services/API/applicationService'
import ApplicantsDataTable from '@/components/ApplicantsDataTable.vue'
import ChangeAgent from '@/components/partials/ChangeAgent.vue'
import ChangeVerifiedAgent from '@/components/partials/ChangeVerifiedAgent.vue'
import AssignVerifiedAgent from '@/components/partials/AssignVerifiedAgent.vue'
import moment from 'moment'
import settings from '@/services/API/settings'
import searchList from '@/services/API/searchList'
import jobService from '@/services/API/jobService'

export default {
	components: {
		ApplicantsDataTable,
		ChangeAgent,
		ChangeVerifiedAgent,
		AssignVerifiedAgent,
	},
	async created() {
		this.fetchAgentList("");
		await incidentService
			.getSingleIncident(this.$route.query.incidentId)
			.then((response) => {

				this.incidentDetail = response.data.data
				this.clientDetails = response.data.data.client
				this.incidentSkills = response.data.data.incidentSkills
				this.incidentJobs = response.data.data.incidentJobs
				// this.submitJob = response.data.data.incidentJobs
				this.items[1].title = response.data.data.workType || response.data.data.title
				this.applicants = response.data.data.applications
			})

		this.serviceReport(this.$route.query.incidentId)
		await incidentService
			.getRelatedIncident(this.$route.query.incidentId)
			.then((response) => {
				response.data.data.forEach((item) => {
					incidentService
						.getSingleIncident(item.relatedIncidentId)
						.then((response) => {
							if (this.linkedIncidents.length === 0) {
								this.linkedIncidents.push(response.data.data)
							} else {
								const incidentSet = new Set(
									this.linkedIncidents.map((item) =>
										JSON.stringify(item)
									)
								)

								if (
									!incidentSet.has(
										JSON.stringify(response.data.data)
									)
								) {
									this.linkedIncidents.push(
										response.data.data
									)
								}
							}
						})
				})
				this.showRelatedIncident = true
			})

		for (let i = 0; i < this.incidentJobs.length; i++) {
			this.submitJob.push(
				new Object({
					remark: this.incidentJobs[i].agentRemark,
					selectedFiles: [],
					selectedDocument: [],
				})
			)
		}

		this.notLoading = true

		this.applications = this.incidentDetail.applications

		if (this.incidentDetail.approvedAgent) {
			this.agentSelected = true
			this.applicationId =
				this.incidentDetail.approvedAgent.Application.id
		} else if (this.incidentDetail.applications) {
			this.applicants = this.incidentDetail.applications
		}

		if (this.agentSelected) {
			await agentService
				.getSingleAgent(this.incidentDetail.approvedAgent.id)
				.then((response) => {
					this.selectedAgent = response.data
				})
			this.agentFeedback = this.selectedAgent.agentFeedback.AgentFeedback
		}

		this.totalWages = this.incidentJobs.reduce(
			(acc, wages) => acc + wages.wages,
			0
		)
		this.totalWorkingPeriod = this.incidentJobs.reduce(
			(acc, workingPeriod) => acc + workingPeriod.workingPeriod,
			0
		)

		this.dateCreated = moment(
			this.incidentDetail.createdAt,
			'YYYY-MM-DD HH:mm:ss'
		).format('MMMM D, YYYY, h:mm A')
		this.incidentJobs.forEach((job) => {
			job.dueDate = moment(job.dueDate, 'YYYY-MM-DD HH:mm:ss').format(
				'MMMM D HH:mm:ss, YYYY'
			)
		})
	},
	methods: {
		async fetchAgentList(searchQuery) {
			await searchList.SearchVerifiedAgent(searchQuery).then((response) => {
				this.agentData = response.data.data
			})
		},

		async assignToVerifiedAgent(data) {
			await applicationService.assignVerifiedAgent(data.incidentId, data.userId).then((response) => {
				if (response.status === 200) {
					window.location.reload();
				}
			});
		},

		showAgent(id) {

		},
		isLocationLink(address) {
			const regex = /^.?(https:\/\/)./g
			return regex.test(address)
		},
		isLink(link) {
			const regex = /^.?(https:\/\/)./g

			return regex.test(link)
		},
		async deleteAccount(id) {
			await incidentService.deleteIncident(id).then((response) => {
				if (response.status == 200) {
					this.isIncidentDeleteDialogOpen = false
					this.$router.push('./')
				}
			})
		},
		async completeJob(jobid, index) {
			const files = this.submitJob[index].selectedFiles.map(
				(image) => image
			)
			const fileDoc = this.submitJob[index].selectedDocument.map(
				(files) => files
			)
			await jobService
				.completeJob({
					files: fileDoc,
					images: files,
					agentRemark: this.submitJob[index].remark,
					jobId: jobid,
					incidenceId: this.incidentDetail.id,
					status: 'complete',
				})
				.then((response) => {
					if (response.status == 200) {
						window.location.reload()
					}
				})
		},

		formatDate(date) {
			return moment(date).format('MM/DD/YYYY,HH:mm')
		},
		formatConsultDate(date) {
			return moment(date).format('MMMM DD, YYYY')

		},
		openFileSystem(index) {
			const maxFiles = 5; // Maximum allowed files (combined for photos and documents)
			const currentFileCount =
				this.submitJob[index].selectedFiles.length +
				this.submitJob[index].selectedDocument.length;

			if (currentFileCount >= maxFiles) {
				alert(`You can only select up to ${maxFiles} files or photos.`);
				return;
			}

			const fileInput = document.createElement('input');
			fileInput.type = 'file';
			fileInput.multiple = true;
			fileInput.style.display = 'none';

			fileInput.addEventListener('change', (event) => {
				const selectedFiles = event.target.files;
				const remainingSlots =
					maxFiles - this.submitJob[index].selectedFiles.length -
					this.submitJob[index].selectedDocument.length;
				const filesToAdd = Array.from(selectedFiles).slice(0, remainingSlots);

				filesToAdd.forEach((file) => {
					const isImage = file.type.startsWith('image/');
					file.displayName = this.truncateFileName(file.name, 15);

					if (isImage) {
						// For images, generate a preview URL
						file.url = URL.createObjectURL(file);
						this.submitJob[index].selectedFiles.push(file);
					} else {
						// For documents, add metadata
						this.submitJob[index].selectedDocument.push(file);
					}
				});

				document.body.removeChild(fileInput);
			});

			// Append the file input to the body
			document.body.appendChild(fileInput);

			// Trigger a click event on the file input
			fileInput.click();
		},

		truncateFileName(fileName, maxLength) {
			if (fileName.length <= maxLength) {
				return fileName // Return the full file name if it's shorter than or equal to the maximum length
			} else {
				const truncatedName = fileName.substring(0, maxLength) // Truncate the file name
				const fileExtension = fileName.split('.').pop() // Get the file extension
				return truncatedName + '...' + fileExtension // Return the truncated file name with ellipsis and extension
			}
		},
		removePhoto(index, i) {
			// Revoke the temporary URL to prevent memory leaks
			URL.revokeObjectURL(this.submitJob[index].selectedFiles[i].url)
			// Remove the photo from the array
			this.submitJob[index].selectedFiles.splice(i, 1)
		},
		removeDocument(index, i) {
			// Remove document from selectedDocument
			this.submitJob[index].selectedDocument.splice(i, 1);
		},
		async changeApplicant(obj) {
			await applicationService
				.changeApplication(
					this.incidentDetail.id,
					obj.applicationId,
					obj.userId
				)
				.then(() => {
					this.changeAgent = false
					window.location.reload()
				})
		},

		closeChangeAgentDialog() {
			this.changeAgent = false
		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		agentProfile(id) {
			// this.$router.push(
			//     `/agent-list/verified-agent/agent-information?agentId=${id}`
			// )
			const agentProfileUrl = `/agent-list/verified-agent/agent-information?agentId=${id}`
			window.open(agentProfileUrl, '_blank')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)
			return `#${hex}`
		},
		getStatusColor(status) {
			return this.statusColorMapper[status] || 'black' // Default to black if status not found
		},
		async handelAssignAgent(data) {
			await agentService.getSingleAgent(data.id).then((response) => {
				this.selectedAgent = response.data
			})
			this.selectedAgentApplicationId = data.applicationId
			this.assignAgent = true
			// this.selectedAgent = data
		},

		async setAgent(incidentId, applicantId) {
			await applicationService
				.approveApplication(incidentId, applicantId)
				.then(() => {
					this.assignAgent = false
					window.location.reload()
				})
		},
		async serviceReport(id) {
			await agentService.agentServiceReport(id).then((response) => {
				if (response.status == 200) {
					this.serviceReportStatus = true
					this.serviceReportData = response.data
				} else if (response.status == 404) {
					this.serviceReportStatus = false
				}
			})
		},
		async completeIncident() {
			// this.moneyTransferDialogue = true;
			await incidentService.completeIncident(
				this.incidentDetail.id,
				this.incidentFeedback
			)
		},
		async reviewIncident(id) {
			await incidentService.reviewIncident(id).then((response) => {
				if (response.status == 200) {
					window.location.reload()
				}
			})
		},
		openFeedbackDialog() {
			this.moneyTransferDialogue = false
			this.feedbackDialogue = true
		},
		openDeleteDialog(jobPhotos) {
			this.selectedJobPhoto = jobPhotos
			this.deleteDialog = true
		},
		async deletePhoto() {
			await jobService
				.deleteJobPhoto(
					this.$route.query.incidentId,
					this.selectedJobPhoto.jobId,
					this.selectedJobPhoto.id
				)
				.then((response) => {
					if (response.status === 200) {
						window.location.reload()
					}
				})
		},
		copyToClipboard() {
			const URL = `${this.url}/agentFeedback?incidentId=${this.incidentDetail.id}&applicationId=${this.applicationId}`
			navigator.clipboard.writeText(URL)
		},
		async closeIncident() {
			await this.completeIncident().then(() => {
				this.feedbackDialogue = false
				window.location.reload()
			})
		},
		openImageDialog(jobImg, index) {
			this.imageDialog = true
			this.jobImages = jobImg
			this.selectedImage = index
		},
		closeDialog() {
			this.imageDialog = false // Close the dialog
		},
	},
	openImageDialog(jobImg, index) {
		this.imageDialog = true
		this.jobImages = jobImg
		this.selectedImage = index
	},
	closeDialog() {
		this.imageDialog = false // Close the dialog
	},
	data: () => ({
		agentData: null,
		serviceReportStatus: false,
		agentFeedback: '',
		isIncidentDeleteDialogOpen: false,
		deleteDialog: false,
		selectedJobPhoto: {},
		notLoading: false,
		linkedIncidents: [],
		incidentFeedback: '',
		showRelatedIncident: false,
		submitJob: [],
		remarks: '',
		changeTab: null,
		selectedFiles: [],
		selectedDocument: [],
		incidentDetail: {},
		clientDetails: {},
		incidentSkills: {},
		incidentCertificateNames: {},
		applicants: [],
		totalApplicants: '',
		changeAgent: false,
		agentSelected: false,
		assignAgent: false,
		applications: [],
		selectedAgent: {},
		selectedAgentApplicationId: '',
		serviceReportData: [],
		feedbackDialogue: false,
		moneyTransferDialogue: false,
		imageDialog: false,
		jobImages: [],
		searchQuery: '',
		selectedImage: 0,
		applicationId: null,
		tab: null,
		tabAgent: null,
		url: import.meta.env.VITE_AGENT_URL,
		items: [
			{
				title: 'Incident List',
				disabled: false,
				color: 'grey',
				href: '/',
			},
			{
				title: '',
				disabled: false,
				href: '',
			},
		],
		colorCode: {
			low: 'gray',
			normal: 'green',
			high: 'yellow',
			urgent: 'red',
		},
		statusColorMapper: {
			'to-do': '#A3A3A3',
			'in-progress': '#FBC816',
			'in-review': '#8045CB',
			complete: '#12C138',
		},
		totalWages: '',
		totalWorkingPeriod: '',
		dateCreated: '',
		headers: [
			{
				text: 'Agent Details',
				value: 'agentDetial',
				width: '40%',
			},
			{
				text: 'Skills',
				value: 'skills',
				width: '45%',
			},
			{
				text: '',
				value: 'assignButton',
				width: '15%',
			},
		],
	}),
}
</script>

<style scoped>
.agent-profile-link {
	text-decoration: none;
	color: black;
}
</style>
